import { FormControlLabel, Radio } from '@mui/material';
import { useState, useRef, useEffect } from 'react';
import styles from './newOfferCard.module.scss';
import { PHONE_ICON } from '../../../../../src/assets/images/icons';
import { ORDER_PHONENO } from '../../../../../commons/Constants/HomePage';
import { makeStyles } from '@material-ui/core';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ContainedButton } from '../../../../../commons/hoc';
import { products } from '../../../../../config/products';
import Image from 'next/image';
import { productImages, VitamindBottle } from '../../../../../src/images';

function NewOfferCard({ offerList, radiovalue, childtoParent, variationName }) {
  const useStyles = makeStyles((theme) => ({
    accordion: {
      // backgroundColor: '',
    },

    expandedHeight: {
      '& div': {
        margin: '0px 0px 0px 0px !important',
        minHeight: 'auto !important',
      },
    },

    customAccordionSummaryContent: {},
    customAccordionSummaryContentNotExpand: {
      flexDirection: 'column',
      margin: '5px 0 5px 0px !important',
    },
    font: {
      fontSize: '15px',
      color: 'red',
    },
  }));

  const classes = useStyles();

  //Maintaining state part
  const [expandedPanel, setExpandedPanel] = useState(0);
  const [expandValue, setExpandValue] = useState(0);

  //handle accord change
  const handleChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : panel);
    setExpandValue(panel);
  };

  //accord detail section multipoints
  const multiPointsFunction = (dataOffer, indexOffer) => {
    return dataOffer.multiPoints?.map((items) => (
      <>
        <div className={`${styles.pointsSubTitle}`}>{items.title}</div>
        {items.points.map((text) => (
          <div
            key={text}
            className={`${styles.innerContainer} ${styles.subInnerContainer}`}
          >
            <div className={styles.tickIcon}>
              <TickIcon></TickIcon>
            </div>
            <Point text={text} />
          </div>
        ))}
      </>
    ));
  };
  // accord summary gheading
  const subHeading = (dataOffer) => {
    return dataOffer.multiPoints?.map((items) => (
      <>
        <div
          style={{
            display: 'flex',
            alignItems: 'flex- start',
            paddingBottom: '12px',
          }}
        >
          <div style={{ marginRight: '8px' }}>
            <TickIcon></TickIcon>
          </div>
          <div>
            <Typography variant="p3" color="primary.black">
              <Point
                text={items.alternateTitle ? items.alternateTitle : items.title}
              />
            </Typography>
          </div>
        </div>
      </>
    ));
  };
  const pointsFunction = (dataOffer) => {
    return dataOffer.points?.map((text) => (
      <div key={text} className={styles.innerContainer}>
        <div className={styles.tickIcon}>
          <TickIcon></TickIcon>
        </div>
        <Point text={text} />
      </div>
    ));
  };

  // Addcart function
  const handleAddCart = (e, data) => {
    e.preventDefault();
    childtoParent(e, data);
  };

  const FreeGiftPromoCard = ({ productType }) => {
    const freeGiftItems = products[productType]?.free_products;
    return (
      freeGiftItems?.length > 0 && (
        <div className={styles.freeGiftWrapper}>
          <div className={styles.freeGiftContainer}>
            <div className={styles.fgLeftBg}>
              <Typography
                className={styles.fgFreeContent}
                variant="h4"
                // color="common.white"
                color="primary.main"
              >
                Free!
              </Typography>
            </div>
            <div className={styles.fgRightContent}>
              <div className={styles.fgImgwrapper}>
                <div className={styles.fgImgContainer}>
                  <Image
                    src={VitamindBottle}
                    layout="fill"
                    placeholder="blur"
                    blurDataURL={VitamindBottle}
                    className={styles.fgProductImg}
                  />
                </div>
              </div>
              <div className={styles.fgDetailsContent}>
                <Typography variant="p3" color="action.gray">
                  Free When You Subscribe to{' '}
                  <span className="noWarp"> Relief Factor</span>
                </Typography>
                <div className={styles.fgProductNames}>
                  <Typography
                    variant="h4"
                    color="primary.main"
                    className="noWarp"
                  >
                    {freeGiftItems[1].name}
                  </Typography>
                  <Typography variant="p3" color="action.gray">
                    or
                  </Typography>
                  <Typography
                    variant="h4"
                    color="primary.main"
                    className="noWarp"
                  >
                    {freeGiftItems[0].name}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    );
  };

  const accord = () => {
    if (!offerList[0]?.isEligibleForSingleOrder) {
      offerList.splice(1, 1);
    }
    return offerList.map((dataOffer, indexOffer) => {
      return (
        <>
          <div
            className={styles.priceCardContainer}
            tabIndex={0}
            style={{
              boxShadow: `0px 0px 15px rgba(0, 0, 0, ${
                (expandedPanel == indexOffer ? 10 : 0) / 100
              })`,
              backgroundColor: expandValue !== indexOffer ? '#F4F4F3' : '',
            }}
            key={indexOffer}
          >
            {indexOffer == 0 ? (
              <div
                className={styles.labelContainer}
                style={{
                  background: dataOffer.labelBgColor,
                  border: `0.5px ${dataOffer?.labelBgColor} solid`,
                }}
              >
                <div className={styles.labelText}>{dataOffer?.labelTitle}</div>
              </div>
            ) : (
              ''
            )}
            <div style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
              <Accordion
                key={indexOffer}
                expanded={expandValue == indexOffer ? true : false}
                disableGutters={true}
                onChange={handleChange(indexOffer)}
                TransitionProps={{
                  unmountOnExit: true,
                  timeout: { enter: 600, exit: 600 },
                  easing: { enter: 600, exit: 600 },
                  style: {
                    height: 'auto',
                    overflow: 'hidden',
                    transition: 'height 0.6s ease-in-out',
                  },
                }}
              >
                {/*----------- Title content part------------------- */}

                <AccordionSummary
                  className={`${
                    expandValue != indexOffer
                      ? styles.customAccordionSummaryContentNotExpand
                      : styles.customAccordionSummaryContent
                  }`}
                >
                  <div className={styles.radioContainer}>
                    <FormControlLabel
                      value={dataOffer?.radioButtonValue}
                      control={<></>}
                      sx={{
                        cursor: expandValue != indexOffer ? 'pointer' : 'auto',
                      }}
                      label={
                        <div className={styles.radioLabelContainer}>
                          <div className={styles.radioLabelPriceContainer}>
                            <Typography
                              variant={
                                expandValue == 0 && expandValue != indexOffer
                                  ? 'h5'
                                  : 'h4'
                              }
                              className={
                                expandValue != indexOffer && expandValue == 0
                                  ? styles.radioLabelnotExpand
                                  : styles.radioLabel
                              }
                              sx={{
                                fontSize: '20px !important',
                              }}
                              color={
                                expandValue != indexOffer
                                  ? 'primary.black'
                                  : 'primary.main'
                              }
                            >
                              {dataOffer?.radioButtonTitle}
                            </Typography>

                            <div className={styles.radioPriceShipContainer}>
                              {expandValue == indexOffer ? (
                                <>
                                  <div className={styles.radioPriceContent}>
                                    <Price
                                      initialPrice={dataOffer?.initialPrice}
                                      discountPrice={dataOffer?.discountPrice}
                                      orginalPrice={dataOffer?.orginalPrice}
                                    ></Price>
                                    {dataOffer?.showShippingHandling && (
                                      <Typography
                                        className={styles.shippingLabel}
                                      >
                                        + S&H
                                      </Typography>
                                    )}
                                  </div>
                                </>
                              ) : dataOffer?.discountPrice ? (
                                <Typography
                                  variant={
                                    expandValue == 0 &&
                                    expandValue != indexOffer
                                      ? 'h5'
                                      : 'h4'
                                  }
                                  className={
                                    expandValue != indexOffer &&
                                    expandValue == 0
                                      ? styles.radioLabelnotExpand
                                      : styles.radioLabel
                                  }
                                  sx={{
                                    fontSize:
                                      expandValue == 0 &&
                                      expandValue != indexOffer
                                        ? '15px !important'
                                        : '20px !important',
                                  }}
                                  color={
                                    expandValue != indexOffer
                                      ? 'primary.black'
                                      : 'primary.main'
                                  }
                                >
                                  ${dataOffer.discountPrice}
                                </Typography>
                              ) : (
                                <Typography
                                  variant={
                                    expandValue == 0 &&
                                    expandValue != indexOffer
                                      ? 'h5'
                                      : 'h4'
                                  }
                                  className={
                                    expandValue != indexOffer &&
                                    expandValue == 0
                                      ? styles.radioLabelnotExpand
                                      : styles.radioLabel
                                  }
                                  color={
                                    expandValue != indexOffer
                                      ? 'primary.black'
                                      : 'primary.main'
                                  }
                                  sx={{
                                    fontSize: '20px !important',
                                  }}
                                >
                                  ${dataOffer.orginalPrice}
                                </Typography>
                              )}
                            </div>
                          </div>
                          {offerList[0].isEligibleForSingleOrder && (
                            <div className={styles.radioButton}>
                              <Radio checked={expandValue == indexOffer} />
                            </div>
                          )}
                        </div>
                      }
                    />
                  </div>

                  {expandValue != indexOffer ? (
                    <div
                      className={`${
                        expandedPanel != indexOffer
                          ? styles.typoheading
                          : styles.typoheadingnone
                      }`}
                    >
                      <Typography
                        variant="div"
                        className={styles.subheadingcontainer}
                      >
                        {dataOffer?.multiPoints && <>{subHeading(dataOffer)}</>}
                      </Typography>
                    </div>
                  ) : (
                    ''
                  )}
                </AccordionSummary>
                {/*----------- body content part------------------- */}
                <AccordionDetails
                  className={`${styles.detailsPadding}
                   ${expandValue != indexOffer ? classes.accordion : ''}
                  `}
                >
                  <div className={styles.pointsContainer}>
                    {dataOffer?.multiPoints ? (
                      <>{multiPointsFunction(dataOffer, indexOffer)}</>
                    ) : (
                      <>{pointsFunction(dataOffer)}</>
                    )}
                    <div className={styles.buttonContainer}>
                      <ContainedButton
                        variant="h5"
                        className={styles.atcBtn}
                        onClick={(e) =>
                          handleAddCart(e, dataOffer?.radioButtonValue)
                        }
                      >
                        Add to Cart
                      </ContainedButton>
                    </div>
                    <div className={styles.contactContainer}>
                      <a
                        className={styles.orderNumber}
                        href={`tel:+1-${ORDER_PHONENO}`}
                      >
                        <span>
                          <PHONE_ICON className={styles.phoneicon} />

                          {ORDER_PHONENO}
                        </span>
                      </a>
                    </div>
                    {indexOffer == 0 &&
                      dataOffer?.radioButtonValue == 'REL-09' &&
                      // Remove once Fg VWO Campaign stops
                      variationName != 'control-a' && (
                        <>
                          <FreeGiftPromoCard
                            productType={dataOffer?.radioButtonValue}
                          />
                        </>
                      )}
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
        </>
      );
    });
  };

  return (
    <>
      {/* Main function starts here */}
      {accord()}
    </>
  );
}

export default NewOfferCard;

function TickIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="7"
      viewBox="0 0 9 7"
      fill="none"
    >
      <path
        d="M7.93042 0.526929L7.93042 0.526926C7.66207 0.260231 7.2276 0.26023 6.95925 0.526926L3.28858 4.1748L1.80541 2.70084L1.8054 2.70084C1.53705 2.43416 1.1026 2.43416 0.834245 2.70084L0.834243 2.70084C0.565018 2.96838 0.565018 3.40283 0.834243 3.67037L2.80299 5.62689L2.803 5.6269C3.07136 5.89357 3.5058 5.89357 3.77416 5.6269L3.77416 5.62689L7.93042 1.49645L7.93042 1.49645C8.19962 1.2289 8.19962 0.794478 7.93042 0.526929Z"
        fill="#479DA6"
        stroke="#479DA6"
        strokeWidth="0.5"
      />
    </svg>
  );
}

const Price = ({ orginalPrice, discountPrice, initialPrice }) => {
  const isSubscription =
    initialPrice !== undefined && discountPrice !== undefined;

  const mainPrice = isSubscription
    ? initialPrice != 0
      ? initialPrice
      : discountPrice
    : orginalPrice; // Buy Once always uses original price

  const secPrice = isSubscription
    ? initialPrice != 0
      ? discountPrice
      : orginalPrice
    : null; // No secondary price for Buy Once

  const haveDisc =
    isSubscription &&
    Number(discountPrice) > 0 &&
    Number(discountPrice) < Number(orginalPrice);

  return (
    <div className={styles.priceContainer}>
      {/* Display Main Price */}
      <Typography
        variant="h4"
        color={'primary.main'}
        sx={{
          fontFamily: 'Whitney Semibold',
          fontSize: '20px !important',
          paddingLeft: '3px !important',
        }}
      >
        {`$${mainPrice}`}
      </Typography>

      {/* Display Strikethrough Price (Only for Subscription) */}
      {haveDisc && isSubscription && (
        <Typography
          variant={haveDisc && isSubscription ? 'h5' : 'h4'}
          color={'primary.main'}
          sx={{
            fontFamily: 'Whitney Semibold',
            fontSize:
              haveDisc && isSubscription
                ? '15px !important'
                : '20px !important',
            opacity: haveDisc && isSubscription ? 0.5 : 1,
            textDecoration:
              haveDisc && isSubscription ? 'line-through' : 'none',
            paddingLeft: '3px !important',
          }}
        >
          {`$${secPrice}`}
        </Typography>
      )}
    </div>
  );
};

const Point = ({ text }) => {
  const regexText = /\(([^)]+)\)/;
  const hasBrackets = (text) => regexText.test(text);
  if (hasBrackets(text)) {
    return (
      <Typography variant="p3" color={'primary.black'} className={styles.point}>
        {text.replace(regexText, '')} {text.match(regexText)[0]}
      </Typography>
    );
  } else {
    return (
      <Typography
        variant="p3"
        color={'primary.black'}
        className={styles.point}
        dangerouslySetInnerHTML={{ __html: text.replace(regexText, '') }}
      ></Typography>
    );
  }
};
